import { createFileRoute } from "@tanstack/react-router";
import { ProfilePage } from "../components/layouts/ProfilePage";
import { requireAuth } from "../lib/auth/route-protection";

export const Route = createFileRoute("/profile")({
  beforeLoad: requireAuth(),
  component: ProfilePage,
});
